
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"data-name":"Capa 1","xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 139 131"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M59.98 47.02c3.19-10.49 13.23-18.25 24.18-18.25 5.93 0 11.41 2.74 15.97 6.39-7.76 4.56-15.97 6.39-31.02 5.47l-.91 10.95c3.19 0 5.47.46 8.21.46 7.3 0 13.69-.91 18.71-2.74v6.39h10.49V44.74c1.82-.91 3.65-2.28 5.02-3.19 4.11 10.04 4.11 25.09-1.37 33.76-5.47.46-12.77-1.37-15.06-4.56l-8.21 6.84c1.37 1.82 3.65 3.65 5.93 4.56-.46 5.02.46 10.49 4.11 16.88l-12.77 5.47-15.06-7.3c2.28-2.74 3.65-5.93 4.11-8.21 1.37-5.02 1.37-10.49 0-13.23v-.91c-10.04-5.47-15.06-17.34-12.32-27.83m50.64 47.45c-7.06-1.98-7.76-6.39-8.21-9.12 1.82 0 3.19.46 5.02.46 2.74 0 5.02-.46 7.3-.91h.91c11.86-13.23 10.49-40.6 1.37-54.29l-3.19-5.47-4.56 3.65-.46.46c-6.39-6.39-15.06-10.49-24.18-10.95-10.49-.46-20.99 4.56-27.83 12.32-1.82-3.19-5.02-11.41-5.02-11.41l-1.37-4.56c-14.6 5.02-22.36 4.11-31.48.46l-4.11 10.04c5.93 2.28 11.41 4.11 18.25 4.11 3.19 0 6.84-.46 10.49-.91.91 1.82 1.37 3.65 2.28 5.47-7.3 1.82-12.77 2.28-18.25 1.37l-1.82 10.49c2.74.46 5.02.91 7.76.91 5.02 0 10.49-.91 16.42-2.74q0 .46-.46.91c-3.65 13.69 1.37 28.74 12.77 37.41 0 3.19-.91 9.58-7.76 13.23l4.11 10.04 25.09 10.95 24.64-10.04 2.28-11.86z","fill":"#fff"}})])
          )
        }
      }
    